import type { SakskategoriSimple } from './SakskategoriSimple';
import type { Saksmelding } from './Saksmelding';
import { SakStatus } from './SakStatus';

export interface CreateSakRequest {
    id?: string;
    opprettetAv?: string;
    emne: string;
    status: string;
    kundeNummer?: string;
    eksternSakId?: string;
    sakskategoriId?: number;
    ekstraSakskategoriList: Array<SakskategoriSimple>;
    saksmeldingList: Array<Saksmelding>;
}

export function createEmptySakRequest(): CreateSakRequest {
    return {
        opprettetAv: '',
        emne: '',
        status: SakStatus.Active.key,
        saksmeldingList: [],
        ekstraSakskategoriList: [],
    };
}

export function convertSakRequestToApiFormat(request: CreateSakRequest) {
    const {
        opprettetAv,
        emne,
        status,
        sakskategoriId,
        kundeNummer,
        saksmeldingList,
        ekstraSakskategoriList,
    } = request;
    return {
        opprettetAv,
        emne,
        status,
        sakskategoriId,
        kundeNummer,
        ekstraSakskategoriList,
        saksmeldingList: saksmeldingList.map((saksmelding) =>
            saksmelding.toSaksmelding(),
        ),
    };
}
